import React from 'react';
import '../styles/styles.css';

const PointsConfirmationModal = ({
    visible,
    estimatedPoints,
    numQuestions,
    onConfirm,
    onCancel,
    title = 'Confirm quiz generation',
    confirmText = 'Yes, continue',
    cancelText = 'Cancel',
    questionText = 'questions',
}) => {
    if (!visible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-container points-confirmation-modal" role="dialog" aria-modal="true">
                <h2 className="points-confirmation-modal__title">{title}</h2>
                <p className="points-confirmation-modal__body">
                    Generating {numQuestions} {questionText} for this document is estimated to cost
                    <span className="points-confirmation-modal__highlight"> {estimatedPoints} points</span>.
                    Do you want to continue?
                </p>
                <div className="points-confirmation-modal__actions">
                    <button type="button" className="button points-confirmation-modal__confirm" onClick={onConfirm}>
                        {confirmText}
                    </button>
                    <button type="button" className="button button--ghost points-confirmation-modal__cancel" onClick={onCancel}>
                        {cancelText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PointsConfirmationModal;
